/** ASCII digits → Persian digits for display (numbers, counts, codes). */
export function faDigits(value: string | number): string {
  return String(value).replace(/[0-9]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)] ?? d);
}
